import { Grip, List } from "lucide-react";

export interface ViewSwitchButtonProps {
  value: boolean;
  setValue: (value: boolean) => void;
}

export const ViewSwitchButton = ({
  value,
  setValue,
}: ViewSwitchButtonProps) => {
  return (
    <div className="flex rounded-lg border-[2px] border-slate-500 overflow-hidden">
      {/* tiled view */}
      <button
        className={`p-2 flex items-center justify-center transition-colors ${
          value
            ? "bg-slate-100 text-slate-800 cursor-default"
            : "hover:bg-slate-100 text-slate-600"
        }`}
        onClick={() => setValue(true)}
        title="Switch to Grid View"
        disabled={value === true}
      >
        <Grip size={18} strokeWidth={2} />
      </button>

      {/* list */}
      <button
        className={`p-2 flex items-center justify-center transition-colors ${
          !value
            ? "bg-slate-100 text-slate-800 cursor-default"
            : "hover:bg-slate-100 text-slate-600"
        }`}
        onClick={() => setValue(false)}
        title="Switch to List View"
        disabled={value === false}
      >
        <List size={18} strokeWidth={2} />
      </button>
    </div>
  );
};
